import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { DeclaracionModelo390DtoProps } from "api/DTOs/DeclaracionModelo390Dto"
import { UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  FieldTemplateThree,
  FieldTemplateTwo,
  renderFieldTemplateOne,
  renderFieldTemplateThree,
  renderFieldTemplateTwo,
} from "../../../PlantillasBloquesTabla"

interface GroupTemplateProps {
  groupTitle: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields: any[]
  setValue: UseFormSetValue<DeclaracionModelo390DtoProps>
}

const GroupTemplate = ({
  groupTitle,
  fields,
  setValue,
}: GroupTemplateProps) => {
  const { t } = useTranslation()
  const lastField = fields[fields.length - 1]
  return (
    <div className='tw-p-4 tw-mb-4 tw-w-full tw-bg-white tw-border-2 tw-border-gray-200 tw-rounded-md'>
      <p className='tw-font-medium tw-text-sm tw-mb-2'>{groupTitle}</p>
      <div className='tw-grid tw-grid-cols-5 tw-items-center tw-border-b tw-font-medium tw-text-sm tw-pb-2 tw-gap-2'>
        <div className='tw-col-start-4 tw-col-span-1 tw-font-medium tw-text-center'>
          {t("taxSummary.tables.baseImponibleOnly")}
        </div>
        <div className='tw-col-start-5 tw-col-span-1 tw-font-medium tw-text-center'>
          {t("taxSummary.declaracion.regimenesDeduccionDiferenciados.text1")}
        </div>
      </div>
      {fields
        .slice(0, 3)
        .map((field: FieldTemplateThree) =>
          renderFieldTemplateThree(field, setValue)
        )}
      {fields
        .slice(3, 5)
        .map((field: FieldTemplateTwo) =>
          renderFieldTemplateTwo(field, setValue)
        )}

      {fields
        .slice(5, 6)
        .map((field: FieldTemplateOne) =>
          renderFieldTemplateOne(field, setValue)
        )}
      <div className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-pt-3'>
        <div className='tw-col-span-4 tw-text-sm tw-font-medium'>
          {lastField.label}
        </div>
        <div className='tw-col-span-1'>
          <InputCurrencyGroup
            suffix='€'
            placeholder='0,00'
            className='tw-w-full tw-h-full tw-text-sm'
            numberGroup={lastField.inputNumber}
            value={lastField.value}
            disabled
          />
        </div>
      </div>
    </div>
  )
}

export default GroupTemplate
